import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { FormValue, FormValueState, MakeProvider, TypedValue, TypedValues, UserService } from '@stylehaven/components';
import { FormPermissionsComplexBaseComponent } from '../base-complex/form-permissions-complex-base.component';

interface TypedSetValues {
    [key: string]: Set<string>;
}

@Component({
    selector: 'med-form-permissions-base',
    templateUrl: '../base-complex/form-permissions-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(FormPermissionsBaseComponent)]
})
export class FormPermissionsBaseComponent extends FormPermissionsComplexBaseComponent {
    constructor(userService: UserService, changeDetectorRef: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
        super(userService, formBuilder, changeDetectorRef);
    }

    propagateChange(formValues: FormValue<TypedValue>[]): void {
        const unwrapped: TypedSetValues = formValues
            .filter(fv => fv.state === FormValueState.SET)
            .map(formValue => FormValue.unwrap(formValue))
            .reduce(this.typedValueListReducer, {} as TypedSetValues);

        const typedValues: TypedValues = this.typedValuesSetToArray(unwrapped);

        super.propagateChange(typedValues as any);
    }

    writeValue(obj: TypedValues | null): void {
        if (obj === null) {
            return;
        }

        const converted: FormValue<TypedValue>[] = [];
        for (const key of Object.keys(obj)) {
            const values: string[] = obj[key];
            for (const value of values) {
                converted.push(new FormValue<TypedValue>({ type: key, value }));
            }
        }
        super.writeValue(converted);
    }

    private typedValuesSetToArray(typedSetValues: TypedSetValues): TypedValues {
        const result: TypedValues = {};
        for (const key of Object.keys(typedSetValues)) {
            result[key] = [...typedSetValues[key]];
        }
        return result;
    }

    private typedValueListReducer(accumulator: TypedSetValues, current: Partial<TypedValue>): TypedSetValues {
        if (!current.type || !current.value) {
            return accumulator;
        }
        if (!accumulator.hasOwnProperty(current.type)) {
            accumulator[current.type] = new Set();
        }
        accumulator[current.type].add(current.value);
        return accumulator;
    }
}
